module.exports = "/_next/static/images/GetStartedBackground-d86eb59b39020804b0a6de7361e91e51.webp";